// Libelles fixes de l'interface.
//
// Ce fichier contenait les scenarios de demonstration du prototype (Camille, la reunion a
// Lyon, la sortie scolaire). Ils ont ete SUPPRIMES : les ecrans lisent desormais l'API.
// Ne restent ici que des libelles, presentes en lecture seule tant que rien cote serveur
// ne les porte.

export type CleConnexion = 'email' | 'cal' | 'loc' | 'transport' | 'meteo';

export interface DefinitionConnexion {
  cle: CleConnexion;
  label: string;
  description: string;
}

/** Sources que Colette saura lire, une fois chacune construite et autorisee. */
export const CONNEXIONS: readonly DefinitionConnexion[] = [
  {
    cle: 'email',
    label: 'Gmail / Email',
    description: 'Résumés, événements et tâches depuis les messages autorisés.',
  },
  {
    cle: 'cal',
    label: 'Calendrier',
    description: 'Lecture des événements et ajout des éléments validés.',
  },
  {
    cle: 'loc',
    label: 'Localisation',
    description: 'Optionnelle. Contexte de trajet et rappels géographiques.',
  },
  { cle: 'transport', label: 'Transport', description: 'Itinéraires, perturbations et alternatives.' },
  { cle: 'meteo', label: 'Météo', description: 'Conditions utiles pour préparer un déplacement.' },
];

/** Domaines de la vie quotidienne que Colette sait traiter. */
export const CATEGORIES = [
  'Travail & réunions',
  'Déplacements pro',
  'Famille & enfants',
  'École & activités',
  'Repas',
  'Courses',
  'Voyages',
  'Documents',
  'Tâches personnelles',
  'Infos importantes',
] as const;
